var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeEnginAgricole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        mask: url(#mask);\n      }\n\n      .cls-6 {\n        filter: url(#luminosity-invert);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-3 {\n        fill: #000;\n        fill-opacity: .6;\n      }\n\n      .cls-4 {\n        fill: #ad974f;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-invert",
    x: -137.2,
    y: -137.2,
    width: 772.7,
    height: 772.7,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "cm",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -137.2,
    y: -137.2,
    width: 772.7,
    height: 772.7,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1aeba00bfc",
    "data-name": "1aeba00bfc"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -137.2,
    y: -137.2,
    width: 772.7,
    height: 772.7
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.5,
    y: 100.6,
    width: 419,
    height: 298.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 52.5,
    y: 100.7,
    width: 362.3,
    height: 235.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 323.8,
    y: 262,
    width: 135.4,
    height: 136
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.9,105.2c12.8-2.3,25.6-4.7,38.6-4.2,35.4.9,70.7,3.7,106.1,5.5,4.1.2,8.4.6,11.9,3,3.8,2.6,5.6,7.2,6.4,11.6,4.2,21.4,9.6,42.5,14.9,63.6.9,3.5,3.5,6.1,5.4,9.1,1.1-.5,2.2-1,3.3-1.4,0-5.8.2-11.5,0-17.3,0-13.3.2-26.6-.2-39.8,0-6,.3-12.2,2.8-17.7,2.2-4.6,6.2-8.6,11.2-9.7,2.6-.6,5.4-.8,8-.2,2.9.7,5.3,3.9,4.3,6.9-1.5,4.8-7,6.4-8.9,11-1.4,2.8-1.5,5.9-1.4,8.9-.4,19.5,0,39.1,0,58.5,34.7,5.8,70.1,9.4,103.4,21.5,5.3,2.5,9.8,7.3,11,13.1,2.6,10.2,3.4,20.7,4.9,31.1-12.1-3.3-24.8-5-37.2-3.2-12.1,1.6-23.6,6.6-33.7,13.4-20.1-14.9-43.1-26.5-67.9-30.8-.7,1-1.3,1.9-1.9,2.9,2.8,2.3,5.3,5.3,8.9,6.1,18.9,5.7,37.3,13.8,52.9,26.1-6.2,10.3-13.9,19.6-18.2,31-3.4,9.4-4.9,19.4-7.2,29.1-5.6.4-11.1,0-16.7.2-14.1.2-28.1,0-42.3.2-9.3.3-18.5,0-27.7.2.2-8.8,1.6-17.5,1.7-26.4,0-21-5.6-42.5-18-59.7-10.9-15.5-26.8-26.9-44.1-34.3-17.5-7.7-37.1-10.6-55.9-7-12.8,2.3-24.9,7.3-36,13.9-2.6,1.6-5.3,3.1-7.4,5.2-1.2,1-2.5,2.7-4.3,1.8-2.6-.9-5.4-2.1-6.9-4.3,0-8.9,4.2-17.8,11.2-23.4,4.8-3.9,10.6-6.3,16.6-7.5,3.3-18.9,6.3-37.8,9.5-56.8.7-4.2,1.5-8.4,2-12.6-2.3-.5-4.2-1.9-5.8-3.4-1.8-1.7-4.3-2.9-4.9-5.4,0-2.8,2.2-5,4.3-6.7,2.1-1.8,4.8-1.8,7.3-2.3ZM181.2,126c-.7,1.4-1.4,2.9-1.3,4.5,0,22.7-.2,45.4.4,68.2.6,4.1,4.1,6.9,7.3,9,16.6,10.5,31,25.1,39.7,42.8,1.4,3.2,4,6.6,7.9,6.7,7.2.4,14.4.3,21.6,0,3.3-22.8,2-46.1-1.9-68.7-3.7-21.1-9.2-41.9-15-62.6-19.6,0-39.2.2-58.8,0ZM107.9,126.4c-3.8,22.7-7.5,45.4-11.3,68.1,9,0,18,.2,27-.2,13.3,0,26.5,0,39.7,0,.2-9.9.2-20,0-29.9,0-12.7.2-25.3,0-38-2.5-.3-5-.2-7.6-.2-16,0-31.8.2-47.7.2ZM365,222.9c2.3,6.5,4.9,12.9,7.9,19.1,1.5-.3,3.6,0,4.7-1.2-2.1-7.9-4.6-15.7-6.8-23.5-2.1,1.6-3.8,3.6-5.7,5.6ZM347.1,224.7c0,.8.4,1.6.8,2.4,2.4,5.3,5.3,10.4,8.1,15.5,1-.4,2-.8,3-1.2-1.7-6.5-3.4-12.9-5.7-19.3-2.3.2-4.7.8-6.2,2.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.2,224.2c17-1.4,34.3,2.3,48.9,10.9,15.5,9,28.1,23.2,34.9,39.8,7.5,17.8,8.4,38.3,2.7,56.7-4.8,15.4-14.3,29.5-26.8,39.7-14.5,11.9-33.3,18.7-52.1,18.7-14.9.2-29.8-3.8-42.6-11.4-14.2-8.4-25.8-21-32.9-35.8-7.5-15.4-9.8-33.2-6.9-50,3.3-19.1,13.5-37,28.4-49.4,13-11,29.5-17.9,46.4-19.2ZM117.3,262.9c-13.1,2.1-25.1,10.4-31.6,21.9-5.4,9.4-7.2,20.9-4.9,31.5,2.1,10.1,7.8,19.3,16,25.6,8.9,7.2,20.7,10.6,32.1,9.4,8.5-.8,16.8-4.3,23.5-9.6,8.9-7,14.9-17.5,16.4-28.7,1.4-10-.8-20.5-6-29.1-4.6-7.7-11.6-13.9-19.8-17.6-8-3.5-17-4.7-25.6-3.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M359.4,271.7c12.6-7,27.6-9.6,41.8-7.6,20.1,2.7,38.6,15.2,48.6,32.8,5,8.4,7.7,18,8.9,27.6v10.1c-1.1,19.4-11.1,38-26.6,49.6-10,7.7-22.2,12-34.7,13.4h-10.1c-8-.7-16-2.5-23.4-5.9-16.3-7.3-29.3-21.4-35.4-38.1-4.8-13.3-5.3-28.1-1.4-41.7,4.9-17.1,16.8-31.9,32.2-40.3ZM388.6,296.7c-9.2.9-17.9,5.8-23.5,13.2-4.8,6.2-7.6,14.1-7.2,22,.4,11.1,6.8,21.6,16.3,27.5,7,4.4,15.7,6.3,23.8,4.6,7.5-1.4,14.5-5.5,19.5-11.4,5.6-6.4,8.8-15.1,8.3-23.7-.4-10.4-6.2-20.4-14.8-26.2-6.5-4.5-14.5-6.8-22.4-6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.7,273.2c8-1.2,16.4.8,23.1,5.2,6.6,4.3,11.8,10.9,14.1,18.5,2.5,7.8,2,16.6-1.5,24.1-3.8,8.4-11.1,15.1-19.8,18.2-8,2.9-17.2,2.6-24.9-1-10.1-4.5-17.8-14-19.9-24.8-1.6-8.1,0-16.8,4.3-23.8,5.2-8.7,14.4-15,24.5-16.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M387.9,305.7c5.7-.9,11.7.3,16.6,3.3,6.4,3.8,11,10.6,12,18,.8,5.8-.5,11.9-3.7,16.9-4.9,7.8-14.2,12.7-23.5,11.7-10-.9-19-8.4-21.9-18-2.1-6.8-.9-14.4,2.9-20.3,3.9-6,10.4-10.4,17.5-11.5Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeEnginAgricole);
export default __webpack_public_path__ + "static/media/Icone-engin-agricole.9d4eac6c095eabf87a7bffebb0702359.svg";
export { ForwardRef as ReactComponent };